import {getMstStore} from '$src/bootstrap/rootSaga'
import {IStore} from '$src/bootstrap/Store'
import {channelOfSnapshots} from '$src/comparableSales/sagas/sagas'
import {take} from 'redux-saga/effects'
import {applySnapshot} from 'mobx-state-tree'
import callEndpoint from '$src/api/sagas/callEndpoint'
import getNotifications from '$src/api/endpoints/notifications/getNotifications'
import {keyBy} from 'lodash'

export default function* usersRootSaga(): Generator {
  const mstStore: IStore = (yield getMstStore()) as $IntentionalAny
  const theChannel = yield channelOfSnapshots(mstStore.notifications)

  while (true) {
    const result = yield callEndpoint(getNotifications)
    const byId = keyBy(result, '_id')
    const list = result.map(({ _id }) => _id)
    applySnapshot(mstStore.notifications, {
      status: 'Loaded',
      byId,
      list,
    })
    yield take(theChannel)
  }
}



// WEBPACK FOOTER //
// ./src/notifications/sagas.tsx